// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xh_a bhe_vn bhe_vf bhe_xb bhe_re bhe_tp bhe_qv"};